module.exports = __webpack_public_path__ + "static/media/user_blue.efaf09af.svg";